import RefreshButton from './refreshButton.view';

export default RefreshButton;
